import gql from "graphql-tag";

export default gql`
	query getPerpetual($id: Int!) {
		getPerpetual(id: $id) {
			serialNumber
			dateCreated
			licenseName
			allowedActivations
			usedActivations
			product {
				description
			}
			activations {
				id
				status
				version
				activated
				deactivated
				computerName
			}
			downloads {
				id
				os
				release
				releaseDate
				architectures
				minOSVersion
				minOSName
				downloadLink
			}
		}
	}
`;

export const readDataFromPerpetual = ({ data }) => data.getPerpetual;
